import cx from 'classnames';
import React, { useState } from 'react';
import { Announcement, LogoPackComp, Navbar, Sidebar, Spacer } from '../../components';

function LogoPack() {
  const [closeSide, setCloseSide] = useState(false)
  const [ann, setAnn] = useState(true)
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            {
              ann && <Announcement
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                onClick={() => setAnn(false)}
                varian="dark"
              />
            }
            <div className="cardContainer">
              <LogoPackComp />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default LogoPack

